import React from "react";
import { Link, useLocation } from "react-router-dom";
import desktopfooter from "../../assets/img/desktopfooter.png";
import footermobile from "../../assets/img/footermobile.png";
import logo from '../../assets/img/logo.png';
import { useScreenSize } from "provider/ScreenSizeProvider";
import { common } from "Data/common";

const FooterPayment = ({footerHeight}) => {
  const { isMobileView } = useScreenSize();

  return (
    <>
      {!isMobileView && (<footer
        className="main_footer position-relative"
      >
        <div className="footer_object">
          <img src={desktopfooter} alt="" className="d-md-block d-none" />
          <img src={footermobile} alt="" className="d-md-none d-block" />
        </div>
        <div className="container-fluid">
          <div className="row justify-content-between border_bottom px-lg-5">
            <div className="col-lg-4">
              <div className="footer_text">
                <div className="heading-footer">
                  {/* <h6>{common?.FOOTER?.ABOUT?.TITLE}</h6> */}
                </div>
                <div className="footerContent">
                  <div
                    className="content_terms"
                    style={{ overflowWrap: "break-word", height:`${footerHeight}px` }}
                  >
                    {/* <p>
                      {common?.FOOTER?.ABOUT?.TEXT_1}
                    </p>

                    <p>
                      {common?.FOOTER?.ABOUT?.TEXT_2}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 Col-md-6">
              <div className="footer_text float-lg-end">
              
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer_text float-lg-end">
               
               
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer_text float-lg-end">
               
           
              </div>
            </div>
          </div>
          <div className="row pt-4 justify-content-between mobile-responsive align-items-center">
            <div className="col-lg-2 col-xxl-2 ">
              <div className="footerlogo">
                <img src={logo} alt="" width="160" />
              </div>
            </div>
            <div className="col-lg-6 col-xxl-7 ">
              <div className="copyright text-center">
                <p className="text-capitalize">
                  {common?.FOOTER?.CONTACT_INFO?.DEVELOPED_BY}
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-xxl-3 ">
              <div className="d-flex gap-3  justify-content-lg-end justify-content-center">
                <div className="terms">
                  <p className="mb-0  pt-0">
                    {common?.FOOTER?.CONTACT_INFO?.COPYRIGHT}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      )}
    </>
  );
};

export default FooterPayment;
